import { render, staticRenderFns } from "./interact-list.vue?vue&type=template&id=9a8ddcf8&scoped=true&"
import script from "./interact-list.vue?vue&type=script&lang=js&"
export * from "./interact-list.vue?vue&type=script&lang=js&"
import style0 from "./interact-list.vue?vue&type=style&index=0&id=9a8ddcf8&prod&lang=scss&scoped=true&"
import style1 from "./interact-list.vue?vue&type=style&index=1&id=9a8ddcf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8ddcf8",
  null
  
)

export default component.exports